import React from "react";
import { Button, Modal } from "react-bootstrap";

export function InActivityPopup({ inactive, setInactive }) {
  const handleInactive = () => {
    setInactive(!inactive);
  }; 
  return (
    <>
      <Modal size="sm" centered show={inactive} onHide={handleInactive}>
        <Modal.Body>
          <div className="text-center">
            <h5 className="m-1 fw-bold">You have been inactive for a while. You will be logged out in 5 minutes due to inactivity. Click anywhere or press 'OK' to stay logged in.</h5>
          </div>
          <div className="d-flex justify-content-center mt-4">
            <Button className="px-4" onClick={handleInactive}>
              OK
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}


 